module.exports = __webpack_public_path__ + "static/arianegroup-dba3493875acea329b49667291666778.png";